export default "__VITE_PUBLIC_ASSET__b9178f78__"